var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogocontract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7957 5.14453V38.1093C15.6065 36.0882 12.9296 33.7814 10.7759 31.2001C11.4671 31.1876 12.4394 31.1432 13.6054 31.0163C16.0039 30.7544 18.1405 28.7049 18.3585 25.6522C18.5765 22.6001 15.96 20.8996 15.0007 20.3326C14.0415 19.7656 11.0327 18.9805 10.7577 17.5851C10.4822 16.1897 12.559 15.9717 12.9951 15.8846C13.4312 15.7975 17.9662 15.7536 17.9662 15.7536V12.1778H13.0822C11.1636 12.1778 9.37544 12.8758 8.06775 14.0093C6.75949 15.1433 6.19246 17.847 7.23884 20.0707C8.28579 22.295 11.3378 23.0362 11.3378 23.0362C14.3904 24.0826 14.8134 25.9078 13.6697 26.8176C11.5997 28.4635 8.37574 26.517 7.15914 25.6647C6.26761 23.8589 5.57533 21.9534 5.08516 19.9511C4.00804 15.5521 4.26422 11.8994 4.45779 10.3571C9.1369 10.1357 12.9831 8.57633 15.4402 7.26464C16.8891 6.49095 18.0237 5.72124 18.7957 5.14453Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57328 9.14711C2.53115 9.3458 1.56163 14.0859 3.07028 20.3409C3.95555 24.0101 5.51545 27.4425 7.70613 30.5424C10.4342 34.4023 14.1501 37.7481 18.7501 40.4876L18.7956 40.515V43C15.6724 41.2983 -1.60257 30.7576 0.712794 6.92794C0.712794 6.92794 12.8777 6.49014 18.7956 0V2.48902L18.5793 2.68828C18.5639 2.70195 17.0325 4.10074 14.4154 5.48929C12.0215 6.75942 8.19517 8.28403 3.56501 8.33413L2.74293 8.34324L2.57328 9.14711Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 15.0898H19.7534V16.1829H19.9698V15.0898Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 15.7539H20.1404V16.1815H21.2221V15.7539Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 15.7539H21.3931V16.1815H22.4747V15.7539Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 15.7539H22.6455V16.1815H23.7272V15.7539Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 15.7539H23.8979V16.1815H25.0366V15.7539Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 15.7539H25.2073V16.1815H26.289V15.7539Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4597 15.7539C26.8503 15.759 27.218 15.8592 27.5414 16.0317V16.1809H26.4597V15.7539Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7845 16.1818H27.7122V16.1328C27.7366 16.1488 27.7606 16.1653 27.7845 16.1818Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 13.8242H19.7534V14.9167H19.9698V13.8242Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 30.25H19.7534V31.3425H19.9698V30.25Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 31.2188H20.1404V31.3411H21.2221V31.2188Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 31.2188H21.3931V31.3411H22.4747V31.2188Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 31.2188H22.6455V31.3411H23.7272V31.2188Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 30.25V31.3425H23.8979V31.2201H24.1439V30.25H25.0366Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 30.25H25.2073V31.3425H26.289V30.25Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 30.25H26.4597V31.3425H27.5414V30.25Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5342 30.25C28.2695 30.5956 27.9951 30.9366 27.7122 31.2731V30.25H28.5342Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 16.3516H19.7534V17.4441H19.9698V16.3516Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 16.3516H20.1404V17.4441H21.2221V16.3516Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 16.3516H21.3931V17.4441H22.4747V16.3516Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 16.3516H22.6455V17.4441H23.7272V16.3516Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 16.3516H23.8979V17.4441H25.0366V16.3516Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 16.3516H25.2073V17.4441H26.289V16.3516Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 16.3516H26.4597V17.4441H27.5414V16.3516Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7016 17.4441H27.7122V16.3516H28.0014C28.327 16.6402 28.5729 17.0165 28.7016 17.4441Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 12.5625H19.7534V13.655H19.9698V12.5625Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 22.668H19.7534V23.7605H19.9698V22.668Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 17.6172H19.7534V18.7097H19.9698V17.6172Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 17.6172H20.1404V18.7097H21.2221V17.6172Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 17.6172H21.3931V18.7097H22.4747V17.6172Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 17.6172H22.6455V18.7097H23.7272V17.6172Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 17.6172H23.8979V18.7097H25.0366V17.6172Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 17.6172H25.2073V18.7097H26.289V17.6172Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 17.6172H26.4597V18.7097H27.5414V17.6172Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8024 18.1324C28.8024 18.1996 28.7995 18.2662 28.7938 18.3317C28.783 18.4609 28.762 18.5873 28.7312 18.7097H27.7122V17.6172H28.7454C28.7688 17.7208 28.7853 17.8267 28.7938 17.9354C28.7995 18.0003 28.8024 18.0658 28.8024 18.1324Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 21.4062H19.7534V22.4993H19.9698V21.4062Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 18.8789H19.7534V19.9714H19.9698V18.8789Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 18.8789H20.1404V19.9714H21.2221V18.8789Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 18.8789H21.3931V19.9714H22.4747V18.8789Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 18.8789H22.6455V19.9714H23.7272V18.8789Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 18.8789H23.8979V19.9714H25.0366V18.8789Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 18.8789H25.2073V19.9714H26.289V18.8789Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 18.8789H26.4597V19.9714H27.5414V18.8789Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6817 18.8789C28.5382 19.3116 28.2741 19.689 27.9285 19.9714H27.7122V18.8789H28.6817Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 10.0352H19.7534V11.1277H19.9698V10.0352Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 10.0352H20.1404V11.1277H21.2221V10.0352Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 10.0352H21.3931V11.1277H22.4747V10.0352Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 10.0352H22.6455V11.1277H23.7272V10.0352Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 10.0352H23.8979V11.1277H25.0366V10.0352Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 10.0352H25.2073V11.1277H26.289V10.0352Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 10.0352H26.4597V11.1277H27.5414V10.0352Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7938 10.0352H27.7122V11.1277H28.7938V10.0352Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0465 10.0352H28.9648V11.1277H30.0465V10.0352Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1367 10.0352C31.2096 10.0477 31.2825 10.0596 31.3559 10.0716V11.1277H30.2173V10.0352H31.1367Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5266 10.0977C31.8813 10.1529 32.2417 10.2007 32.6083 10.2406V11.127H31.5266V10.0977Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7791 10.2617C33.1343 10.2982 33.4947 10.3266 33.8607 10.3477V11.1299H32.7791V10.2617Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1715 11.1286H34.0315V10.3555C34.0509 10.3566 34.0708 10.3572 34.0907 10.3583C34.118 10.5747 34.1459 10.8331 34.1715 11.1286Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3318 18.8789H32.6085V19.9714H32.0881C32.202 19.6201 32.2845 19.2552 32.3318 18.8789Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M33.703 18.8789C33.6319 19.2307 33.5527 19.5883 33.4639 19.9515C33.4622 19.9583 33.4605 19.9646 33.4588 19.9714H32.7791V18.8789H33.703Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5322 12.5625H28.7941V12.669C28.7076 12.6314 28.6205 12.5961 28.5322 12.5625Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9648 12.5625H30.0465V13.4062C29.7123 13.15 29.3503 12.928 28.9648 12.7464V12.5625Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2173 12.5625H31.3559V13.655H30.3494C30.3061 13.6169 30.2617 13.5793 30.2173 13.5429V12.5625Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6083 12.5625H31.5266V13.655H32.6083V12.5625Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8607 12.5625H32.7791V13.655H33.8607V12.5625Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2621 13.655H34.0315V12.5625H34.2535C34.2632 12.9029 34.2666 13.2679 34.2621 13.655Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 32.7773H19.7534V33.8699H19.9698V32.7773Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 32.7773H20.1404V33.8699H21.2221V32.7773Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 32.7773H21.3931V33.8699H22.4747V32.7773Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 32.7773H22.6455V33.8699H23.7272V32.7773Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 32.7773H23.8979V33.8699H25.0366V32.7773Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 32.7773V32.8508C25.9553 33.1964 25.6115 33.5362 25.2574 33.8699H25.2073V32.7773H26.289Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 31.5117H19.7534V32.6042H19.9698V31.5117Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 31.5117H20.1404V32.6042H21.2221V31.5117Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 31.5117H21.3931V32.6042H22.4747V31.5117Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 31.5117H22.6455V32.6042H23.7272V31.5117Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 31.5117H23.8979V32.6042H25.0366V31.5117Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 31.5117H25.2073V32.6042H26.289V31.5117Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5095 31.5117C27.1918 31.8818 26.8628 32.2456 26.5235 32.6042H26.4597V31.5117H27.5095Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 23.9336H19.7534V25.0261H19.9698V23.9336Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 6.24609H19.7534V7.3386H19.9698V6.24609Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 6.24609H20.1404V7.3386H21.2221V6.24609Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 6.91684V7.3387H21.3931V6.26953C21.7267 6.47961 22.0876 6.69708 22.4747 6.91684Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2461 7.33736H22.6455V7.01172C22.7964 7.09598 22.9507 7.18023 23.1089 7.26506C23.1539 7.28897 23.2006 7.31345 23.2461 7.33736Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 35.3008H19.7534V36.3939H19.9698V35.3008Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 35.3008H20.1404V36.3939H21.2221V35.3008Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3931 35.3008H22.4747V36.2185C22.3979 36.2777 22.3205 36.3358 22.243 36.3939H21.3931V35.3008Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6321 35.3008C23.3105 35.5672 22.9814 35.8297 22.6455 36.0881V35.3008H23.6321Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 34.0391H19.7534V35.1316H19.9698V34.0391Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 34.0391H20.1404V35.1316H21.2221V34.0391Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 34.0391H21.3931V35.1316H22.4747V34.0391Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 34.0391H22.6455V35.1316H23.7272V34.0391Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0741 34.0391C25.0616 34.0504 25.0491 34.0624 25.0366 34.0738C24.6676 34.4154 24.2879 34.7513 23.8979 35.0803V34.0391H25.0741Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7534 37.8281H19.9698V37.9693C19.898 38.0154 19.8257 38.0615 19.7534 38.1077V37.8281Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1876 37.8281C20.1717 37.8384 20.1563 37.8486 20.1404 37.8589V37.8281H20.1876Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 36.5664H19.7534V37.6589H19.9698V36.5664Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1404 36.5664H21.2221V37.1323C20.9681 37.3099 20.7103 37.4853 20.4484 37.6589H20.1404V36.5664Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0136 36.5664C21.8092 36.7167 21.6026 36.8653 21.3931 37.0133V36.5664H22.0136Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 20.1406H19.7534V21.2331H19.9698V20.1406Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 20.1406H20.1404V20.5056H21.2221V20.1406Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 20.1406H21.3931V20.5056H22.4747V20.1406Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 20.1406H22.6455V20.5056H23.7272V20.1406Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 20.1406H23.8979V20.5056H25.0366V20.1406Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 20.1406H25.2073V20.5056H26.289V20.1406Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 20.1406V20.2272C27.218 20.3997 26.8508 20.4999 26.4597 20.505V20.1406H27.5414Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3559 21.4648V22.4976H30.4695C30.8025 22.189 31.1008 21.8423 31.3559 21.4648Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6083 21.4062H31.5266V22.4993H32.6083V21.4062Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0671 21.4062C32.976 21.7086 32.8798 22.0086 32.7791 22.3063V21.4062H33.0671Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5359 13.8242H31.3557V14.7938C31.1177 14.4419 30.8427 14.1174 30.5359 13.8242Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6083 13.8242H31.5266V14.9167H32.6083V13.8242Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8607 13.8242H32.7791V14.9167H33.8607V13.8242Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2592 13.8242C34.253 14.1721 34.2393 14.537 34.2171 14.9167H34.0315V13.8242H34.2592Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1079 16.3516H32.6083V17.4441H32.3385C32.2958 17.0678 32.2178 16.7028 32.1079 16.3516Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8607 16.3516H32.7791V17.4441H33.8607V16.3516Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M34.097 16.3516C34.077 16.5315 34.0554 16.7142 34.0315 16.8992V16.3516H34.097Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 25.1953H19.7534V26.2878H19.9698V25.1953Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0294 20.1406H32.6084V21.2331H31.5056C31.513 21.2217 31.5198 21.2098 31.5267 21.1978C31.7276 20.8654 31.8962 20.5118 32.0294 20.1406Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4161 20.1406C33.3233 20.5084 33.2242 20.8722 33.1178 21.2331H32.7791V20.1406H33.4161Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5432 15.0898H32.6084V16.1829H32.0516C31.9184 15.7992 31.7476 15.4337 31.5432 15.0898Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8607 15.0898H32.7791V16.1829H33.8607V15.0898Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2068 15.0898C34.1846 15.4422 34.1539 15.8072 34.1152 16.1829H34.0315V15.0898H34.2068Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7532 5.14453C19.8226 5.19634 19.8944 5.24985 19.9695 5.30451V6.07365H19.7532V5.14453Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0894 6.07195H20.1404V5.42578C20.4216 5.62675 20.7387 5.84422 21.0894 6.07195Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 11.2969H19.7534V12.3894H19.9698V11.2969Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 11.2969H20.1404V12.1765H21.2221V11.2969Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 11.2969H21.3931V12.1765H22.4747V11.2969Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 11.2969H22.6455V12.1765H23.7272V11.2969Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 11.2969H23.8979V12.1765H25.0366V11.2969Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 11.2969H25.2073V12.1765H26.289V11.2969Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4597 11.2969H27.5414V12.2818C27.1907 12.2146 26.8292 12.1787 26.4597 12.177V11.2969Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7122 11.2969H28.7938V12.3894H28.0076C27.9103 12.3626 27.8118 12.3381 27.7122 12.3165V11.2969Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0465 11.2969H28.9648V12.3894H30.0465V11.2969Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3559 11.2969H30.2173V12.3894H31.3559V11.2969Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6083 11.2969H31.5266V12.3894H32.6083V11.2969Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8607 11.2969H32.7791V12.3894H33.8607V11.2969Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2484 12.3894H34.0315V11.2969H34.1858C34.212 11.622 34.2342 11.9869 34.2484 12.3894Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 7.50781H19.7534V8.60089H19.9698V7.50781Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 7.50781H20.1404V8.60089H21.2221V7.50781Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 7.50781H21.3931V8.60089H22.4747V7.50781Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5758 7.50781C23.6259 7.53343 23.6759 7.55905 23.7272 7.5841V8.60089H22.6455V7.50781H23.5758Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8979 7.66797C24.2549 7.84389 24.6352 8.02151 25.0366 8.19686V8.59993H23.8979V7.66797Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M26.01 8.6025H25.2073V8.27344C25.4663 8.38445 25.7339 8.49433 26.01 8.6025Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 8.77344H19.7534V9.86594H19.9698V8.77344Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2221 8.77344H20.1404V9.86594H21.2221V8.77344Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 8.77344H21.3931V9.86594H22.4747V8.77344Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7272 8.77344H22.6455V9.86594H23.7272V8.77344Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0366 8.77344H23.8979V9.86594H25.0366V8.77344Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 8.77344H25.2073V9.86594H26.289V8.77344Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4597 8.77344C26.8081 8.9021 27.1691 9.02792 27.5414 9.14861V9.86481H26.4597V8.77344Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7122 9.19922C28.0628 9.31023 28.4232 9.41613 28.7938 9.51576V9.86133H27.7122V9.19922Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9648 9.5625C29.3172 9.65473 29.6776 9.74183 30.0465 9.82154V9.86253H28.9648V9.5625Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2389 9.86394H30.2173V9.85938C30.2247 9.86109 30.2315 9.86223 30.2389 9.86394Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3563 17.6172H32.6085V18.7097H32.3506C32.3688 18.5195 32.3785 18.3271 32.3785 18.1324C32.3785 17.9588 32.3705 17.7868 32.3563 17.6172Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8607 17.6172V18.039C33.8232 18.2599 33.7822 18.4837 33.7378 18.7097H32.7791V17.6172H33.8607Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 28.9844H19.7534V30.0774H19.9698V28.9844Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0367 28.9844H24.144V30.0774H25.0367V28.9844Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 28.9844H25.2073V30.0774H26.289V28.9844Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 28.9844H26.4597V30.0774H27.5414V28.9844Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7938 28.9844V29.9038C28.7511 29.9619 28.7079 30.0199 28.6646 30.0774H27.7122V28.9844H28.7938Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4488 28.9844C29.2911 29.2155 29.1299 29.4444 28.9648 29.6715V28.9844H29.4488Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 27.7227H19.7534V28.8152H19.9698V27.7227Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 26.457H19.7534V27.5495H19.9698V26.457Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0367 26.457H24.144V27.5495H25.0367V26.457Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 26.457H25.2073V27.5495H26.289V26.457Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 26.457H26.4597V27.5495H27.5414V26.457Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7938 26.457H27.7122V27.5495H28.7938V26.457Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0465 26.457H28.9648V27.5495H30.0465V26.457Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9813 26.457C30.7837 26.8254 30.5782 27.1897 30.3636 27.5495H30.2173V26.457H30.9813Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0367 27.7227H24.144V28.8152H25.0367V27.7227Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 27.7227H25.2073V28.8152H26.289V27.7227Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 27.7227H26.4597V28.8152H27.5414V27.7227Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7938 27.7227H27.7122V28.8152H28.7938V27.7227Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0465 27.7227V28.0705C29.89 28.321 29.7289 28.5692 29.5638 28.8152H28.9648V27.7227H30.0465Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2617 27.7227C30.2469 27.7471 30.2321 27.771 30.2173 27.795V27.7227H30.2617Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0367 25.1953H24.144V26.2878H25.0367V25.1953Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 25.1953H25.2073V26.2878H26.289V25.1953Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 25.1953H26.4597V26.2878H27.5414V25.1953Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7938 25.1953H27.7122V26.2878H28.7938V25.1953Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0465 25.1953H28.9648V26.2878H30.0465V25.1953Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3559 25.1953V25.7322C31.2637 25.9183 31.1686 26.1039 31.0718 26.2878H30.2173V25.1953H31.3559Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6154 25.1953C31.5864 25.2574 31.5568 25.3194 31.5266 25.3815V25.1953H31.6154Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0367 24.082H24.144V25.0242H25.0367V24.082Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 24.082H25.2073V25.0242H26.289V24.082Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5414 23.9766V25.0235H26.4597V24.0813C26.8292 24.079 27.1907 24.0437 27.5414 23.9766Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7938 23.9336V25.0261H27.7122V23.9438C27.7287 23.941 27.7446 23.9376 27.7611 23.9336H28.7938Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0465 23.9336H28.9648V25.0261H30.0465V23.9336Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3559 23.9336H30.2173V25.0261H31.3559V23.9336Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1716 23.9336C32.0202 24.3014 31.8619 24.6657 31.6951 25.0261H31.5266V23.9336H32.1716Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3591 23.7628C28.5072 23.7122 28.6518 23.6558 28.7941 23.5938V23.7628H28.3591Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0465 22.8555V23.7624H28.9648V23.5153C29.3497 23.3343 29.7123 23.1122 30.0465 22.8555Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3559 22.668V23.7605H30.2173V22.7175C30.2372 22.7016 30.2571 22.6845 30.2771 22.668H31.3559Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6538 22.668C32.639 22.7101 32.6237 22.7522 32.6083 22.7944C32.4916 23.1194 32.3692 23.4411 32.2405 23.7605H31.5266V22.668H32.6538Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2483 32.6039C29.5301 32.2691 29.8034 31.9298 30.0681 31.5859V32.6039H29.2483Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3313 31.5156V32.5916C31.3273 32.5973 31.3233 32.6024 31.3193 32.6081H30.2388V31.5156H31.3313Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0797 31.5156C31.8896 31.8003 31.6966 32.0792 31.5024 32.3531V31.5156H32.0797Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1274 33.8692C28.358 33.6227 28.584 33.3733 28.8043 33.1211V33.8692H28.1274Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0682 32.7773V33.8699H28.9751V32.9254C29.0184 32.8764 29.0611 32.8269 29.1032 32.7773H30.0682Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1946 32.7773C30.9202 33.1525 30.6424 33.5169 30.3623 33.8699H30.2388V32.7773H31.1946Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0468 30.25H31.3314V31.3425H30.2566C30.457 31.0783 30.6523 30.8113 30.843 30.5421C30.9119 30.4447 30.9796 30.3474 31.0468 30.25Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5949 30.25V30.7185C32.4623 30.9292 32.3285 31.137 32.193 31.3425H31.5024V30.25H32.5949Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8857 30.25C32.8459 30.3149 32.806 30.3798 32.7656 30.4447V30.25H32.8857Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5409 34.4805V35.1323H26.8828C27.106 34.9171 27.3257 34.7002 27.5409 34.4805Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8042 34.0391V35.1316H27.7117V34.3055C27.7976 34.2173 27.883 34.1284 27.9673 34.0391H28.8042Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0682 34.0391V34.2349C29.8182 34.5423 29.5666 34.8412 29.3144 35.1316H28.9751V34.0391H30.0682Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9763 28.814C32.1904 28.4633 32.3965 28.1087 32.5946 27.75V28.814H31.9763Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8581 27.7227V28.5459C33.8103 28.6364 33.7619 28.7258 33.7129 28.8152H32.7656V27.7227H33.8581Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2844 27.7227C34.2002 27.8906 34.1148 28.0574 34.0288 28.2225V27.7227H34.2844Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8581 26.457V27.5495H32.7656V27.4362C32.9404 27.1129 33.1078 26.7861 33.2695 26.457H33.8581Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M34.885 26.457C34.7177 26.8282 34.5457 27.192 34.3693 27.5495H34.0288V26.457H34.885Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1628 30.0786C31.2192 29.9955 31.2756 29.9118 31.3314 29.8281V30.0786H31.1628Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5949 28.9883V30.0814H31.5024V29.5713C31.6283 29.3783 31.7512 29.1841 31.8719 28.9883H32.5949Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M33.619 28.9883C33.4135 29.3606 33.2034 29.725 32.9888 30.0814H32.7656V28.9883H33.619Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 36.3932C25.7631 36.1643 26.0227 35.9332 26.2778 35.6992V36.3932H25.4995Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M27.541 35.3008V36.3939H26.4485V35.5422C26.5345 35.4619 26.6204 35.3816 26.7052 35.3008H27.541Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8042 35.3008V35.7061C28.5912 35.9413 28.3783 36.1701 28.166 36.3939H27.7117V35.3008H28.8042Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1658 35.3008C29.1021 35.3731 29.0389 35.4448 28.9751 35.516V35.3008H29.1658Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6868 6.24609H26.2777V6.50001C26.075 6.41632 25.8781 6.33149 25.6868 6.24609Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4485 6.24609H27.541V6.98563C27.1618 6.85184 26.7975 6.71293 26.4485 6.57003V6.24609Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7117 6.24609H28.8042V7.3386H28.618C28.3077 7.24466 28.0054 7.14674 27.7117 7.04541V6.24609Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0682 6.24609H28.9751V7.3386H30.0682V6.24609Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3313 6.24609H30.2388V7.3386H31.3313V6.24609Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5858 6.24609C32.5887 6.24609 32.5921 6.24723 32.5949 6.2478V7.3386H31.5024V6.24609H32.5858Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7656 6.28125C33.1442 6.35526 33.5091 6.42073 33.8581 6.4788V7.33846H32.7656V6.28125Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0288 6.50781C34.4154 6.57044 34.7809 6.62395 35.1213 6.6695V7.33957H34.0288V6.50781Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2922 6.69141C35.697 6.74378 36.0636 6.78534 36.3847 6.81722V7.33871H35.2922V6.69141Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5554 6.83203C37.0638 6.88099 37.4396 6.90547 37.6485 6.91743V7.33644H36.5554V6.83203Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8732 7.33625H37.8191V6.92578C37.8299 6.92635 37.8356 6.92635 37.8356 6.92635C37.8487 7.06355 37.8612 7.20019 37.8732 7.33625Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2344 38.9231C22.3192 38.8645 22.4035 38.8053 22.4871 38.7461V38.9231H22.2344Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7513 37.832V38.9245H22.6582V38.6268C23.0243 38.366 23.3835 38.1013 23.7359 37.832H23.7513Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0144 37.832H23.9219V38.9245H25.0144V37.832Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2778 37.832V38.2482C26.0222 38.4828 25.7688 38.7076 25.5183 38.9245H25.1853V37.832H26.2778Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7263 37.832C26.6335 37.9197 26.5407 38.0062 26.4485 38.0911V37.832H26.7263Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9578 37.6591C24.3176 37.3802 24.67 37.0967 25.0144 36.8086V37.6591H23.9578Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2778 36.5664V37.6589H25.1853V36.6649C25.224 36.6324 25.2627 36.5994 25.3014 36.5664H26.2778Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M27.541 36.5664V37.0372C27.3281 37.2507 27.1168 37.4579 26.9062 37.6589H26.4485V36.5664H27.541Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0026 36.5664C27.9058 36.6672 27.8085 36.7662 27.7117 36.8647V36.5664H28.0026Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9604 0.221462V1.0202H19.7532V0C19.8215 0.0745796 19.8904 0.14859 19.9604 0.221462Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M20.788 1.02126H20.1316V0.398438C20.3439 0.613067 20.5631 0.820866 20.788 1.02126Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9629 42.8828C19.9629 42.8828 19.9612 42.8839 19.9606 42.8839C19.8861 42.9255 19.8166 42.9642 19.7534 42.9984V42.8828H19.9629Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8534 25.1953H33.858V26.2878H33.353C33.5278 25.9269 33.694 25.5625 33.8534 25.1953Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1213 25.1953V25.9223C35.0689 26.0447 35.0154 26.1666 34.9619 26.2878H34.0288V25.1953H35.1213Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4255 25.1953C35.3816 25.3041 35.3372 25.4122 35.2922 25.5198V25.1953H35.4255Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2961 40.1835C20.6098 39.991 20.919 39.7958 21.2241 39.5977V40.1835H20.2961Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4873 39.0938V40.1863H21.3948V39.4889C21.5935 39.3585 21.7904 39.227 21.9857 39.0938H22.4873Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7513 39.0938H22.6582V40.1863H23.7513V39.0938Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0144 39.0938V39.3516C24.6603 39.6477 24.3147 39.9261 23.9794 40.1863H23.9219V39.0938H25.0144Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3197 39.0938C25.2747 39.1319 25.2297 39.1706 25.1853 39.2082V39.0938H25.3197Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M19.799 40.4885C19.853 40.4561 19.9071 40.4236 19.9606 40.3906V41.4507H19.7534V40.5159L19.799 40.4885Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2241 40.3555H20.1316V41.448H21.2241V40.3555Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4873 40.3555V41.2857C22.4081 41.3415 22.3307 41.395 22.2539 41.448H21.3948V40.3555H22.4873Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7587 40.3555C23.7587 40.3555 23.7535 40.3595 23.7513 40.3612C23.3704 40.6526 23.0049 40.9208 22.6582 41.1662V40.3555H23.7587Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9606 41.6211H19.7534V42.7142H19.9606V41.6211Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2241 41.6211V42.1301C20.8592 42.3612 20.5358 42.5559 20.2625 42.7142H20.1316V41.6211H21.2241Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0028 41.6211C21.7904 41.764 21.5872 41.8972 21.3948 42.0208V41.6211H22.0028Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9606 1.19141H19.7534V2.28448H19.9606V1.19141Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9833 1.19141C21.063 1.25972 21.1432 1.32747 21.2241 1.39408V2.28448H20.1316V1.19141H20.9833Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M22.407 2.28274H21.3948V1.53125C21.7221 1.79427 22.0603 2.04477 22.407 2.28274Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2102 7.50781H30.0681V7.727C29.7761 7.65811 29.4903 7.58467 29.2102 7.50781Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2388 7.50781H31.3313V7.98774C30.9589 7.9217 30.5946 7.84769 30.2388 7.76685V7.50781Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5024 7.50781H32.5949V8.17618C32.2238 8.13178 31.8594 8.07826 31.5024 8.01734V7.50781Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7656 7.50781H33.8581V8.29175C33.4881 8.26898 33.1237 8.23653 32.7656 8.19611V7.50781Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0288 7.50781H35.1213V8.33502L34.9835 8.33331C34.6613 8.3299 34.3431 8.31908 34.0288 8.302V7.50781Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2922 7.50781H36.3847V8.60089H35.8604L35.8058 8.34242L35.2922 8.33673V7.50781Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6485 7.50781H36.5554V8.60089H37.6485V7.50781Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9677 8.60089H37.8191V7.50781H37.888C37.9193 7.87559 37.946 8.23938 37.9677 8.60089Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1194 10.0352H36.3847V11.1277H36.2344C36.1997 10.699 36.1587 10.3323 36.1194 10.0352Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6485 10.0352H36.5554V11.1277H37.6485V10.0352Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0479 11.1277H37.8191V10.0352H38.0309C38.0411 10.4024 38.0468 10.7667 38.0479 11.1277Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8962 8.77344H36.3847V9.86594H36.0961C36.0357 9.4401 35.9845 9.19017 35.9754 9.14804L35.8962 8.77344Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6485 8.77344H36.5554V9.86594H37.6485V8.77344Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0257 9.86594H37.8191V8.77344H37.9768C37.9979 9.14064 38.0138 9.505 38.0257 9.86594Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1213 23.9336V25.0261H34.0288V24.7858C34.1461 24.504 34.2588 24.2194 34.3675 23.9336H35.1213Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9077 23.9336C35.7744 24.3036 35.6367 24.6674 35.4938 25.0261H35.2922V23.9336H35.9077Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3108 12.5625H36.3848V13.655H36.3188C36.3233 13.2702 36.3199 12.9058 36.3108 12.5625Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6485 12.5625H36.5554V13.655H37.6485V12.5625Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0269 12.5625C38.0149 12.9303 37.9984 13.2946 37.9774 13.655H37.8191V12.5625H38.0269Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2234 4.98047H23.7511V5.2805C23.5695 5.17973 23.3936 5.07953 23.2234 4.98047Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9219 4.98047H25.0144V5.93292C24.703 5.78263 24.4086 5.63347 24.1337 5.48772C24.0619 5.44958 23.9913 5.41201 23.9219 5.37386V4.98047Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1853 4.98047H26.2778V6.07297H25.3111C25.269 6.05305 25.2269 6.03369 25.1853 6.01377V4.98047Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M27.541 4.98047H26.4485V6.07297H27.541V4.98047Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8956 4.98047C28.1996 5.08693 28.503 5.18713 28.8042 5.28163V6.07297H27.7117V4.98047H27.8956Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9751 5.33594C29.3429 5.4498 29.7078 5.55569 30.0682 5.65361V6.07433H28.9751V5.33594Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2388 5.69922C30.6088 5.79828 30.9737 5.8888 31.3313 5.97249V6.07382H30.2388V5.69922Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7751 6.0732H31.5024V6.01172C31.5941 6.03278 31.6846 6.05328 31.7751 6.0732Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7534 2.45312H19.9606V2.67686L19.7534 2.48558V2.45312Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1316 2.45312H21.2241V3.54563H21.0419C20.6115 3.22682 20.3035 2.97347 20.1316 2.82716V2.45312Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4873 2.45312H21.3948V3.54563H22.4873V2.45312Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6611 2.45312C23.0169 2.68825 23.3807 2.91085 23.7513 3.12206V3.54563H22.6582V2.45312H22.6611Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5299 3.5461H23.9219V3.21875C24.1228 3.33147 24.3255 3.44021 24.5299 3.5461Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3948 3.71875H22.4873V4.53514C22.0757 4.27497 21.7102 4.02789 21.3948 3.80358V3.71875Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6582 3.71875H23.7513V4.81126H22.936C22.8415 4.75433 22.7487 4.69796 22.6582 4.6416V3.71875Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8675 3.71875C24.9164 3.74323 24.9654 3.76714 25.0144 3.79105V4.81126H23.9219V3.71875H24.8675Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1853 3.875C25.5468 4.0475 25.9117 4.21032 26.2778 4.36404V4.81322H25.1853V3.875Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4197 4.81162H26.4485V4.43359C26.7719 4.56681 27.0958 4.69263 27.4197 4.81162Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2476 11.2969H36.3848V12.3894H36.3056C36.2931 11.9937 36.2726 11.6282 36.2476 11.2969Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6485 11.2969H36.5554V12.3894H37.6485V11.2969Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0479 11.2969C38.0474 11.6646 38.0417 12.029 38.032 12.3894H37.8191V11.2969H38.0479Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8708 22.5C34.958 22.229 35.0416 21.9569 35.1213 21.6836V22.5H34.8708Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3847 21.4062H35.2922V22.4993H36.3847V21.4062Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7091 21.4062C36.659 21.5879 36.6078 21.7678 36.5554 21.9471V21.4062H36.7091Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3155 13.8281H36.3844V14.9206H36.2756C36.2961 14.542 36.3092 14.1771 36.3155 13.8281Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6485 13.8281H36.5554V14.9206H37.6485V13.8281Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9671 13.8281C37.9438 14.1965 37.9153 14.5603 37.8823 14.9206H37.8191V13.8281H37.9671Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5249 20.1406H36.3845V21.2331H35.2471C35.2624 21.1779 35.2772 21.1227 35.292 21.0675C35.3569 20.8255 35.4196 20.583 35.4782 20.3387C35.4941 20.2727 35.5095 20.2067 35.5249 20.1406Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0336 20.1406C36.946 20.5095 36.8537 20.8739 36.7564 21.2331H36.5554V20.1406H37.0336Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8156 22.6719H35.1213V23.7644H34.4319C34.5668 23.4029 34.6949 23.0385 34.8156 22.6719Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3346 22.6719C36.2174 23.0414 36.0955 23.4057 35.9686 23.7644H35.2922V22.6719H36.3346Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7925 18.8789H36.3846V19.9714H35.5642C35.649 19.6014 35.7248 19.237 35.7925 18.8789Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3103 18.8789C37.2363 19.2478 37.1577 19.6122 37.0741 19.9714H36.5554V18.8789H37.3103Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2655 15.0898H36.3845V16.1829H36.179C36.216 15.8072 36.2444 15.4428 36.2655 15.0898Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6485 15.0898H36.5554V16.1829H37.6485V15.0898Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8663 15.0898C37.8515 15.2453 37.8356 15.3995 37.8191 15.5533V15.0898H37.8663Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M36.162 16.3516H36.3846V17.4441H36.0288C36.0812 17.0706 36.125 16.7062 36.162 16.3516Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6485 16.3516V16.9083C37.6223 17.0877 37.5955 17.2664 37.5671 17.4441H36.5554V16.3516H37.6485Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0041 17.6133H36.3844V18.7058H35.8242C35.8925 18.3346 35.9523 17.9702 36.0041 17.6133Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5403 17.6133C37.48 17.9822 37.4139 18.346 37.3439 18.7058H36.5554V17.6133H37.5403Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0742 34.0391C25.0617 34.0504 25.0491 34.0624 25.0366 34.0738V34.0391H25.0742Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8027 18.1306C28.8027 18.1978 28.7999 18.2644 28.7942 18.3298V17.9336C28.7999 17.9985 28.8027 18.064 28.8027 18.1306Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5056 21.2346C31.513 21.2232 31.5199 21.2112 31.5267 21.1992V21.2346H31.5056Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6539 22.668C32.6391 22.7101 32.6238 22.7522 32.6084 22.7944V22.668H32.6539Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7577 40.3594C23.7577 40.3594 23.7529 40.3631 23.7507 40.3647V40.3594H23.7577Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2468 21.236C35.2622 21.1808 35.277 21.1255 35.2918 21.0703V21.236H35.2468Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogocontract);
export default __webpack_public_path__ + "static/media/Logocontract.b33f5c10c7686213b0de228ce0993733.svg";
export { ForwardRef as ReactComponent };